@import "prism-code-editor/themes/prism-tomorrow.css";
